import gettext from '@sdk/lang/gettext';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import type { OnboardingTrialFlag } from '@sdk/authentication/types/apiTypes';

import type { OnboardingStepsConfigType } from '../onboardingChecklist.types';

import ChecklistRow from './ChecklistRow';

type Props = {
  steps: OnboardingTrialFlag[];
  config: OnboardingStepsConfigType;
};

const ChecklistContent = ({ steps, config }: Props) => (
  <>
    <Column>
      <Text14 pTop={10} themeColor={ThemeColorType.gray}>
        {gettext(
          'Complete the following steps to learn how Sling works and hit the ground running.'
        )}
      </Text14>
    </Column>
    <Column top={18} bottom={18}>
      <HorizontalSeparator />
    </Column>

    {steps.map((step, index) => (
      <ChecklistRow
        key={step.key}
        text={config[step.key]?.content}
        isChecked={step.completed}
        isLast={index === steps.length - 1}
        onClick={config[step.key].action}
      />
    ))}
  </>
);

export default ChecklistContent;
